<app-header></app-header>
<div class="auth-wrap">
    <router-outlet></router-outlet>
</div>
